var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSeasonSs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 854.36 865.71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 424.86,
    cy: 450.84,
    fill: "#333",
    r: 107.26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 42
  }, /*#__PURE__*/React.createElement("path", {
    d: "m270.17 209.96 63.4 115.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.57 587.43 67.85 113.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.58 532.35-113.43 67.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m674.44 309.16-113.77 66.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m698.05 539.23-127.22-35.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.95 421.33-127.22-35.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.29 729.49 30.51-128.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.64 302.27 30.52-128.45"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSeasonSs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Season_SS.9e33709328065e6b41934e09eeac5c5c.svg";